// eslint-disable-next-line import/no-anonymous-default-export
export default {
    translation: {
        next_btn: "続行",
        logout: "ログアウト",
        back_btn: "戻る",

        errors: {
            invalid_password: "無効なパスワード。 6 ～ 20 文字で、大文字、小文字、数字を含める必要があります。",
            hear_us_error: "当社についてどこで知ったかを選択してください。",
            email_validation: "メールには「@」記号が含まれている必要があります",
            required_field: "この項目は必須です。",
            conf_email_error: "メールアドレスと確認メールアドレスが一致しません",
            conf_password_error: "パスワードとパスワードの確認が一致しません",
            canadian_email_error: "カナダのメールアドレスは受け付けられません",
            enter_characters: "11文字以内で入力してください。",
            tax_enter_characters: "10文字以内で入力してください。",
            conf_ssn_error: "SSN と SSN の確認が一致しません",
            conf_tax_error: "Tax ID と Tax ID の確認が一致しません",
            years_old_error: "18 歳以上である必要があります。",
            exp_date_error: "現在の日付より後の日付である必要があります。",
            exp_issue_date_error: "発行日以降である必要があります。",
            select_country_error: "国を選択してください。",
            exp_earlier_date_error: "現在の日付よりも前の日付である必要があります。",
            liquid_assets_error: "流動資産は純資産と同額かそれ以下でなければならない",
            low_assets_error: "このアカウントでは流動資産の選択が低すぎます",
            low_income_error: "このアカウントでは流動資産の選択が低すぎます",
            low_worth_error: "このアカウントでは年間収入の選択が低すぎます",
            invalid_signature: "署名は、アプリケーションの名前と一致する必要があります。",
            indicate_error: "所有権の割合は合計して 100% になる必要があります",
            liquid_error: "お客様の流動純資産が 20,000 ドル未満の場合、証拠金を承認することはできません。 現金口座を選択してください。",
            valid_date: "有効な日付を MM/DD/YYYY 形式で入力してください。",
            custodial_year: "18 歳未満である必要があります",
            main_user_ssn: "メインユーザーの SSN と同じにすることはできません",
            zip_code_format: "郵便番号が無効です。 NNNNN または NNNNN-NNNN である必要があります",
            required_file_upload: "ファイルのアップロードが必要です",
            or: "または",
            trusted_success: "Kontak sing dipercaya kasil disimpen.",
            missing_id: "ID aplikasi ilang.",
            trusted_failed: "Gagal nyimpen kontak sing dipercaya.",
            server_error: "Kesalahan server nalika nyimpen data."
        },

        register: {
            user_registration: "新規ユーザー登録",
            for_limited: "チョイストレード口座開設には最低$ 100が必要です。証拠金勘定を申請する場合、最低$ 2,000が必要です。",
            username: "ユーザー名",
            email: "Eメール",
            password: "秘密の言葉",
            confirm_password: "秘密の言葉の確認",
            hear_us: "あなたは私たちをどこで知りましたか？",
            citizen_status: "市民権の状況",
            type_account: "開くアカウントのタイプを選択します。",
            individual: "個人",
            joint_account_type: "共同口座",
            custodial: "保管",
            ira: "IRA",
            specialty_account_type: "特殊アカウント",
            already_sign_in: "すでにアプリケーションを開始していますか? サインイン。",
            important_info: "政府によるテロ資金供与やマネーロンダリング活動との闘いを支援するため、連邦法はすべての金融機関に対し、口座を開設する各個人を特定する情報を取得、検証、記録することを義務付けています。 これがあなたにとって意味すること: アカウントを開設する際、当社はあなたの名前、住所、生年月日、およびあなたを特定できるその他の情報を尋ねます。 また、運転免許証やその他の身分証明書の提示をお願いする場合もあります。",
            security_disclaimer: "米国証券商品およびサービスは、米国で規制されているブローカーである ChoiceTrade を通じて提供されます。ChoiceTrade は、いかなる証券または投資戦略も推奨しません。ChoiceTrade にアクセスした Web サイトと ChoiceTrade は別個の会社です。ChoiceTrade 以外の Web コンテンツおよび投稿は、ChoiceTrade の見解を反映するものではなく、ChoiceTrade によって完全性または正確性について確認されていません。",
            big_saving_text: "申請を完了して大幅な節約を実現する方法をご覧ください。 数分しかかかりません。"
        },

        personal: {
            welcome: "ようこそ",
            welcome_pls: "下のアプリケーションを続けてください。",
            personal_info: "個人情報",
            title: "タイトル",
            mr: "氏",
            ms: "さん",
            mrs: "夫人",
            dr: "先生",
            first_name: "名前",
            last_name: "苗字",
            date_of_birth: "生年月日 MM/DD/YYYY",
            ssn: "SSN * XXX-XX-XXXX",
            confirm_ssn: "SSN * XXX-XX-XXXXを確認してください",
            mobile_phone: "昼間の連絡先 (国番号と番号)",
            marital_status: "配偶者の有無",
            single: "独身",
            married: "既婚",
            divorced: "離婚",
            widow: "未亡人",
            iden_type: "識別タイプ",
            state_dl: "州のDL",
            state_id: "州ID",
            national_id: "国民ID",
            passport: "パスポート",
            iden_number: "識別番号",
            issue_date: "発行日MM / DD / YYYY",
            expiration_date: "有効期限MM / DD / YYYY",
            permanent_address: "恒久的な住所",
            address2: "住所２",
            city: "市、県",
            select_country: "国を選択",
            zip_code: "郵便番号",
            select_state: "州を選択",
            different_address: "他の郵送先住所",
            mailing_address: "送り先",
            mailing_address2: "送り先2",
            mailing_city: "市、県",
            mailing_country: "国を選択",
            mailing_zip_code: "郵便番号",
            mailing_state: "州を選択",
            identification: "識別",
            street_number_name: "番地と名前",
            issue_exp_date: "私のIDには発行日や有効期限がありません",
            take_photo: "政府発行の身分証明書のコピーを提出してください。"
        },

        financial: {
            thanks: "ありがとう",
            need_financial_info: "今、あなたの財務情報が必要です",
            financial_info: "財務情報",
            employment_status: "雇用状況",
            employed: "雇用された",
            self_employed: "自営業",
            retired: "退職者",
            homemaker: "主婦",
            student: "学生",
            unemployed: "失業者",
            school_name: "School Name",
            occupation: "職業",
            accounting: "会計",
            agriculture: "農業",
            banking_and_finance: "銀行・金融",
            clerical: "事務職",
            construction: "建設",
            consulting: "コンサルティング",
            customer_service: "カスタマーサービス - コールセンター",
            education: "教育",
            engineer: "エンジニア",
            government: "政府",
            healthcare: "健康管理",
            hotel_restaurant: "ホテルとレストラン",
            information: "情報技術",
            internet: "インターネットとEコマース",
            legal: "法的",
            management_executive: "管理とエグゼクティブ",
            manufacturing: "製造業",
            marketing: "マーケティング",
            media: "メディア - ジャーナリズム",
            non_profit: "非営利団体",
            real_estate: "不動産",
            retail: "小売",
            sales: "販売",
            science: "科学",
            security: "社会保障/年金",
            sports: "スポーツ",
            travel: "旅行と観光",
            wholesale: "卸売業",
            company_name: "会社名",
            business_address: "勤務先住所",
            city: "市、県",
            select_country: "国を選択",
            zip_code: "郵便番号",
            select_state: "州を選択",
            source_of_income: "主な収入源",
            job: "仕事",
            personal_saving: "個人貯蓄",
            spouse: "配偶者/ 親",
            inheritance: "継承",
            investment: "投資",
            retirement_plan: "退職制度",
            real_estate_investment: "不動産投資",
            stock_retirement: "株式退職年金",
            family_wealth: 'ご家族のご資産',
            passive_income: "受動的収入",
            royalties: "ロイヤリティー",
            property_income: "不動産収入",
            portfolio_income: "ポートフォリオ収入",
            other: "その他",
            source_of_wealth: "主なご資産の元",
            personal_income_saving: "個人収入/貯蓄",
            sale_of_business: "ビジネスの売却",
            annual_income: "年収",
            liquid_assets: "当座資産",
            over: "以上",
            net_worth: "純資産",
            sold_business_name: "売却した商号",
            sale_amount: "販売金額",
            date_sold: "販売日"
        },

        affiliation: {
            welcome: "ようこそ",
            affiliated: "次",
            affiliation_information: "配偶者情報",
            yes: "はい",
            no: "いいえ",
            aff_company_name: "会社名",
            your_position: "あなたの位置",
            aff_person_name: "加盟者の名前",
            agent_list: "プロセスのサービスのためにエージェントをリストアップしてください",
            financial_regulator: "あなたの国の金融規制当局の会員資格を示す文書のコピーをスキャンして、service@choicetrade.comにメールしてください。",
            political_organization: "その役人および直属の家族（元配偶者を含む）および関連する外国の政治組織の名前を記入してください。",
            name: "名前",
            organization: "組織",
            ownership_disclosure: "所有権の開示",
            ownership_disclosed: "証券取引法の規則14b-1（c）に基づき私たちは、発行者に名前",
            privacy_and_policy: " ChoiceTrade を読んで同意します",
            privacy_policy: "プライバシーポリシー",
            are_member: "あなたご自身か、ご家族の方が世帯主です",
            NFA_or_CFTC: "あなたまたはあなたの家族のメンバーは、登録されたブローカー/ディーラー、保険会社、銀行、米国でビジネスを行っている投資顧問、またはSEC、FINRA、NFA、CFTCを含む米国の取引所または自主規制機関に所属または雇用されていますか？ ？",
            foreign_shell: "この申請は外国のシェル銀行のために提出されていますか？",
            owner_affiliated: "このアカウントの所有者は外国のシェルバンクと提携していますか？",
            owner_offer: "アカウント所有者は外国のシェルバンクにサービスを提供していますか",
            bankruptcy_proceeding: "破産手続きの対象になったことはありますか",
            commodity_account: "あなたは法的紛争に遭ったことがありますか？",
            commodity_firm: "閉じたことがありますか？",
            business_with_you: "口座の使用中にこの口座に資金を供給するために使用されるこの口座の所有者ではない人物または団体から資金を受け取りますか？ （あなたが誰かのお金でいつでも口座に資金を提供しようとしているなら、あなたと取引することはできません。",
            financial_institution: "他の金融機関から口座を振り込みますか？",
            close_associate: "この申請は、現職の政治家、元政治家（定義を参照）、直属関係の家族、または親密関係者のためにご提出されていますか？",
        },

        account: {
            welcome: "ようこそ",
            option_trading: "あなたのオプショントレーディング経験は、オプション取引の希望レベルと一致する必要があります。経験がなければ",
            account_privileges: "アカウント特権",
            account_profile: "アカウントのプロファイルを選択",
            cash_margin: "現金担保",
            cash: "現金",
            day_trade1: "この口座で",
            day_trade2: "デイトレード",
            day_trade3: "をするつもりですか",
            cash_margin_accounts: "CashMargin アカウントには、現金アカウントに対する追加の権限があります。 各アカウントのプロファイルにカーソルを移動すると、詳細が表示されます。 (保管口座および IRA には現金口座のみが許可されます)",
            specify_trading_level: "この口座に希望するオプション取引レベルを指定してください。 カバード コールを除き、ほとんどのレベルのオプション取引機能には投機的な投資目的が必要です。 ご希望のオプション取引の度合いを以下にご記入ください。",
            option_trading_level: "特定のオプション目的および要求されるオプション取引レベル",
            choose_one: "1つを選択",
            level1: "目的：収入",
            level2: "目的：推測",
            level3: "目的：推測",
            level4: "目的：推測",
            level5: "目的：推測",
            level6: "私はこのアカウントにオプション取引機能を追加したくない",
        },

        experience: {
            welcome: "ようこそ",
            investment_experience: "あなたの投資経験と投資目的について教えてください。",
            previous_investment: "以前の投資経験",
            stocks: "在庫:",
            year: "年",
            average_size: "平均サイズ",
            average_number: "平均数",
            options: "オプション",
            investment_objective: "投資目的",
            speculative_activity: "あなたにとって最も重要な投資目的をクリックしてください。 最初の 2 つの目標は、申請プロセスの前半で選択したアカウントの種類と機能が原因で無効になる場合があります。 たとえば、ペニー株への投資、証拠金の使用、またはオプション取引 (オプション レベル 1 以外) は本質的に投機的なものであり、高いリスク許容度が必要です。 投資目的のリスク許容度が低く、そのような選択をしたい場合は、戻ってそれらの機能のチェックを外す必要があります。",
            objective: "客観的",
            risk_tolerance: "投資目的。 所得。 リスク許容度: 中程度。 対象期間: 5 年未満 (収入という投資目標は、投資から収入を得ることを目指しており、他の目的に比べて元本価値の損失のリスクが低いことが過去に実証されている投資に関心があることを示します。典型的な投資の例 には、高品質の短期債券商品やカバード コール オプションが含まれる場合があります。お客様は、行う各投資が投資目的およびリスク プロファイルと一致しているかどうかを判断する責任を単独で負います。ChoiceTrade はお客様に代わってこれを監視しません。)",
            capital_appreciation: "投資目的 : 資本の増加。 リスク許容度：投機。 時間範囲: 5年未満 (資本感謝の投資目標は、投資の元本価値を長期的に増加させることを目指しており、この目標を達成するために元本価値の損失リスクが平均以上であることが過去に証明されている証券に積極的に投資することを示しています。いくつかの例 典型的な投資には、普通株式、低品質の中期債券商品、株式ミューチュアル ファンドおよびインデックス ファンドが含まれる場合があります。行う各投資が投資目的およびリスク プロファイルと一致しているかどうかを判断するのは、お客様自身の責任です。ChoiceTrade は監視しません。 これはあなたのためです。この目的を選択した場合、OTC (ペニー) 株やオプションを購入することはできません。)",
            time_horizon: "投資目的: 投機。 リスク許容度: 推測。 時間の地平線。 5 年未満 (投機という投資目標は、投資の元本価値の大幅な増加を求めており、これまでに高い損失リスクが実証されている証券に投資することで、それに応じてより大きなリスクを受け入れる意思があることを示しています) この目的を追求するための元本価値、場合によっては元本投資を超える場合があります。短期取引の機会を利用しようとする場合があり、これにはポジションの迅速な確立と清算が含まれる場合があります。典型的な投資の例には、低品質の長期投資が含まれる場合があります。 債券商品、新規株式公開、変動性の高いまたは低価格の普通株式、プットまたはコール オプションの売買、株式または指数のスプレッド、ストラドルおよび/または組み合わせ、および短期またはデイ トレーディング戦略の使用。 お客様が行った各投資がお客様の投資目的およびリスク プロファイルと一致しているかどうかを判断する責任は、ChoiceTrade が単独で負います。ChoiceTrade はお客様に代わってこれを監視しません。 お客様がペニー株またはオプション (カバード コールを除く) を取引したい場合、またはデイトレード (あらゆる種類の証券) を希望している場合、これがお客様のアカウントでこれらの投機証券の取引が許可される前に当社が受け入れる唯一の目的です。)",
            document_delivery: "書類の送付",
            additional_fees: "以下の書類を郵送ではなく電子メールで受け取ることに同意します（紙の書類を郵送で受け取る場合は追加料金がかかります）",
            trade_conf_email: "電子メールによる取引確認。",
            account_statement_email: "電子メールによるアカウント明細書。",
            proxy_statement_email: "電子メールによる代理声明。",
            prospectuses_email: "電子メールによる目論見書。",
            tax_document_email: "税務書類を電子メールで送信します。",
        },

        conditions: {
            thanks: "ありがとう",
            terms_condition: "次に、以下の各契約のいくつかの利用規約を確認し、同意する必要があります。 （各タブを開いてチェックを入れてください）",
            financial_information: "開示",
            customer_agreement: "顧客同意書",
            conditions_governing: "私は、顧客契約に含まれるこのアカウントに適用される利用規約を読み、理解し、 ",
            conditions_governing2: "私は、現在有効な利用規約、および私への事前の通知なしに随時修正される利用規約に拘束されることに同意します。 私は、申請書に入力したすべての情報が、私の知識と信念の限りにおいて正しいことを保証します。 将来変更があった場合は、ChoiceTrade に書面で速やかに通知することに同意します。",
            arbitration_agreement: "私は、このアカウントが顧客契約の第 18 項および第 19 項に規定されている仲裁合意に準拠していることを理解しています。 私は、私のアカウントを管理する仲裁契約および顧客アカウント契約を受領したことを認めます。 私は、アクティブ トレーディングのリスク開示声明、証拠金開示声明、および ChoiceTrade のプライバシーに関する声明を読み、理解していることを認めます。 私は、(i) この口座申し込みはいかなる勧誘にも基づいて行われたものではないこと、(ii) ChoiceTrade はその清算会社と提携しておらず、その代理人ではないこと、および (iii) ここに記載された内容はいかなる証券のオファーまたは勧誘でもないことを理解し、認めます。 私は、ChoiceTrade が特定の証券や投資戦略の潜在的な価値や適合性に関して、投資、税金、法律、会計に関するアドバイスを提供しないことを認めます。 。",
            fee_acknowledgement: "料金の確認",
            service_fee: "一部のプラットフォームには月額サービス料金がかかります。 私は、ChoiceTrade が私のアカウントから引き落としを行うことを承認することにより、サービス料金を支払うことを認め、これに同意します。 私は、契約に基づいて発見者料金が支払われる場合があることを認めます。",
            margin_agreement1: "マージン契約 (Velox)",
            margin_agreement: "証拠金合意",
            margin_agreement2: "証拠金合意",
            margin_terms: "私は証拠金補充のすべての条項に同意します。 私は、私のマージン口座証券が私によって借りられるか、他人に貸与される可能性があることを認めます。",
            margin_risk: "証拠金リスク開示声明",
            options_agreement: "オプション契約",
            any_material_change: " 私は、私の財務状況および/または投資目標に重大な変化があった場合に、Choicetrade にアドバイスすることに同意します。 オプション補足のすべての条項に同意します。 私は、次のリンクにある開示文書「標準化オプションの特性とリスク」を読み、オプション取引に固有の特別なリスクを認識していることを認めます。",
            option_disclosures: "オプションの開示",
            options_supplement: "オプションの補足",
            taxpayer_id_number: "納税者 ID 番号の証明書 (W-9 の代わり) (税務目的の米国人ではない場合は、このセクションをスキップしてください)",
            notified_irs: "IRS からバックアップ源泉徴収が免除される旨の通知を受けた場合は、このボックスにチェックを入れます。 (該当しない場合、または税務上の米国人ではない場合は、このセクションをスキップしてください)",
            penalty_of_perjury: "偽証罪に処せられることを前提として、私は次のことを証明します。",
            number_1: "1. この申請書に表示されている番号は私の正しい納税者番号です (または番号が発行されるのを待っています)。",
            number_2: "2. 私は予備源泉徴収の対象ではありません。次の理由により、(a) 予備源泉徴収が免除されている、または (b) 障害の結果として予備源泉徴収の対象となる旨の内国歳入庁 (IRS) から通知を受けていない すべての利息または配当を報告すること、または (c) IRS が私に予備源泉徴収の対象ではなくなったことを通知したこと (不動産取引、住宅ローンの利息の支払い、担保不動産の取得または放棄、個人への寄付には適用されません) 退職金口座 (IRA)、および利息と配当以外の支払い。)",
            number_3: "3. 私は米国人です（米国居住外国人を含む）。 証明手順 -- IRS から、納税申告書ですべての利息と配当を報告していないため、現在バックアップ源泉徴収の対象となっていると通知された場合は、上記の項目 2 を取り消す必要があります。)",
            clearing_authorization: "清算会社の認可",
            client_auth_condition: "当社の清算会社は、さまざまなレポートを閲覧するためのアクセスを提供します。 このサービスを提供することを承認するには、このボックスにチェックを入れてください。",
            agreew8_heading: "フォーム W8-BEN 納税状況証明書",
            agreew8_text: "上記の認定に同意します。 私は、IRS フォーム W8-BEN の偽証陳述書に含まれる宣言を行う必要があること、および以下の署名によってこの宣言を行うことを認めます。 私はここにフォーム W8-BEN を電子的に送信し、ChoiceTrade が清算会社とそれを共有することを許可することに同意します。",
            agreew8_text2: "私は、米国税法上、米国市民、米国居住外国人、またはその他の米国人ではないことを証明し、外国人ステータスを証明し、該当する場合は租税条約の特典を請求するために、このフォームとともに該当する W-8 BEN フォームを提出します。",
            w8_form: "W8-フォーム",
            alpa1: "私は、Alpaca Securities LLCおよびChoiceTradeの口座規約、ならびに本契約書に記載されている私に適用されるその他すべての規約、開示事項、および免責事項を読み、理解し、これらに拘束されることに同意します。",
            alpa2: "また、",
            alpa3: "本契約書には第43条に紛争前仲裁条項が含まれていることを承認します。",
            alpa4: "「同意する」をクリックすることにより、私はこの契約書に電子的に署名し、私の電子署名は申請書に物理的に署名して返送するのと同じ効果を持つことを理解します。",
            alpa_heading: "Alpaca顧客契約",
            finder_heading: "外国人ファインダー契約書",
            finder_text1: "下記に署名した顧客は、以下の各事項を承認し、同意します。",
            finder_text2: "私は米国国民でも居住者でもありません。 法人を代表して申請する場合、その法人は米国の法人ではなく、米国に本拠地を置いてもいません。",
            finder_text3: "ChoiceTrade は私に、ChoiceTrade で口座を開設するよう勧誘していません。 私が ChoiceTrade でビジネスを行うために、ChoiceTrade を私の管轄区域に登録する必要はありません",
            finder_text4: "私のアカウントは、ChoiceTrade が米国以外の発見者に支払う補償協定の対象となっています。",
            finder_text5: "(「ファインダー」) 取引関連の報酬。 以下に記載がない限り、私の手数料スケジュールは ChoiceTrade の通常のスケジュールです。 ファインダーは、ChoiceTrade のブローカー、従業員、または代理店ではありません。また、私または私たちは、ChoiceTrade とのビジネスに関してファインダーと取引することはありません。 ファインダーとの関係を除き、ChoiceTrade はファインダーとは何の関係もありません。 私/私たちは、私/私たちの ChoiceTrade アカウントのあらゆる側面に関して、ChoiceTrade と直接取引します。",
            finder_text6: "この申請書に署名することにより、私/私たちは、前述の申請書の発効日を理解し、承認し、同意したことになります。",
            privacy: "プライバシー",
            trading_header: "貿易協定",
            trading_text1: "を読んで同意します",
            trading_text2: "取引認可契約",
            trading_text3: "この申請書に記入して署名することによって。",
            foreignfinder: "ChoiceTrade は米国以外の企業に支払います。 発見者、Red Information Technology Ltd. は、私が支払う手数料と証拠金利息のうち、ChoiceTrade が負担する部分の利益の 2 分の 1 を取引関連の報酬として受け取ります。 この比率は変更される可能性があります。"
        },

        review: {
            next: "次、",
            review_info: "自分の情報を見直してください。",
            click_here: "ここをクリック",
            print_page: "印刷ページへ。",
            review_app: "申請の確認",
            registration: "登録:",
            edit: "編集",
            citizen_status: "市民権ステータス:",
            account_type: "アカウントの種類:",
            personal_info: "個人情報：",
            title: "タイトル:",
            first_name: "ファーストネーム:",
            last_name: "苗字:",
            date_of_birth: "生年月日:",
            ssn: "Ssn:",
            marital_status: "配偶者の有無:",
            permanent_address: "本籍地:",
            address2: "アドレス2:",
            city: "市:",
            country: "国:",
            zip_code: "郵便番号:",
            employment: "雇用:",
            employment_status: "雇用状況:",
            contact_info: "連絡先情報:",
            phone: "昼間の連絡先:",
            email: "Eメール:",
            financial_info: "財務情報:",
            source_of_income: "主な収入源:",
            annual_income: "年収:",
            liquid_assets: "当座資産:",
            net_worth: "純資産:",
            account_privileges: "アカウントの権限:",
            investment_account_type: "投資口座の種類:",
            investment: "投資口座タイプ:",
            mailing_address: "郵送先住所:",
            perm_address: "本籍地と同じ:",
            mailing_address2: "アドレス2:",
            mailing_city: "市:",
            mailing_state: "州:",
            mailing_country: "国:",
            mailing_zip_code: "郵便番号:",
            previous_investment: "過去の投資経験:",
            stocks: "株式:",
            year: "年:",
            average_size: "平均サイズ:",
            average_number: "年間平均トランザクション数:",
            options: "オプション:",
            investment_objective: "投資目的:",
            investment_experience_text: "投資目的: 投機。 リスク許容度: 推測。 時間の地平線。 5年未満",
            specific_option_level: "特定のオプションの目的と要求されるオプション取引レベル:"
        },

        signature: {
            sign_and_submit: "署名して提出",
            signature: "サイン:",
            primary_account: "主要アカウント所有者",
            signature_line: "署名欄に姓名を入力して文書に署名してください。",
            arbitration_agreement: "私は、このアカウントが顧客契約の第 18 項および第 19 項に規定されている仲裁合意に準拠していることを理解しています。 私は、私のアカウントに適用される仲裁契約および顧客アカウント契約を受領したことを認めます。",
            terms_and_conditions: "私は、顧客契約に含まれるこのアカウントに適用される利用規約を読み、理解し、同意したことを表明します。 私は、現在有効な利用規約、および私への事前の通知なしに随時修正される利用規約に拘束されることに同意します。 私は、申請書に入力したすべての情報が、私の知識と信念の限りにおいて正しいことを保証します。 将来的に変更があった場合は、ChoiceTrade に書面で速やかに通知することに同意します。 私は以下を読んで理解したことを認めます",
            risk_disclosure_statement: "アクティブトレーディングのリスク開示声明、証拠金開示声明、ChoiceTrade プライバシー声明。",
            service_fee: "私は、(i) この口座申請はいかなる勧誘にも基づいて行われたものではないこと、(ii) ChoiceTrade はその清算会社と提携しておらず、その代理人ではないこと、および (iii) ここに記載された内容はいかなる証券のオファーや勧誘でも無いことを理解し、認めます。 管轄区域内での製品またはサービスの提供または販売が現地の法律または規制に反する場合。 私は、ChoiceTrade が特定の証券や投資戦略の潜在的価値や適合性に関して、投資、税金、法律、会計に関するアドバイスを提供しないことを認めます。 一部のプラットフォームには月額サービス料金がかかります。",
        },

        welcome_to: {
            welcome_to: "ChoiceTradeへようこそ",
            upload: "アップロード",
            account_funding: "アカウントの資金調達",
            funding_instruction: "アカウントが承認され、アカウント番号を取得したら、すぐに入金することができます。",
            click_here: "資金調達の手順については、ここをクリックしてください。",
            attention: "注意: 追加のフォームが必要です。 以下の指示に従ってください。 申請の審査プロセスを開始するには、次の書類を提出してください。 以下の UPLOAD 機能を使用して、ドキュメントを安全にアップロードできます。 (書類をアップロードできない場合は、service@choicetrade.com に別途電子メールを送信していただければ、申請書に添付させていただきます。電子メールで送信する場合は、必ずアカウントに指定した電子メール アドレスから送信してください。 応用..",
            application: "米国の申請者: 現在の運転免許証のコピーを提出してください。 (期限切れのライセンスは受け付けられません)。 口座への入金に使用する最新の銀行取引明細書の最初のページをお送りください。 アカウントと組み合わせて複数の銀行を使用する場合は、すべての銀行にこの情報を提供してください。 注意してください: 銀行取引明細書に記載されている名前と住所は、申請した情報と正確に一致する必要があります。 当社が登録した情報と一致しない口座から資金を送金した場合、資金は返金され、銀行手数料やその他の手数料が発生します。",
            non_resident: "非居住者: 現在のパスポートのコピーを提出してください。 ご希望の場合のみ、アカウントへの入金に使用する最新の銀行取引明細書の最初のページをお送りください。 アカウントと組み合わせて複数の銀行を使用する場合は、すべての銀行にこの情報を提供してください。 注意してください: 銀行取引明細書に記載されている名前と住所は、申請した情報と正確に一致する必要があります。 いずれかの住所の公共料金請求書などの住所を証明するものを送付する必要があります。 当社が登録した情報と一致しない口座から資金を送金した場合、資金は返金され、銀行手数料やその他の手数料が発生します。",
            complete_app: "おめでとう！ 申請が完了しました。 現時点では、参照用の申請確認番号は次のとおりです。",
            complete_app_number: "(これはあなたの口座番号ではありません)。",
            complete_app_continue1: "まだお持ちでない場合は、運転免許証、パスポート、国民 ID カードなどの現在お持ちの政府発行の ID のコピーをご提出ください。この書類には、お名前、写真、生年月日が記載されている必要があります。提出後、ChoiceTrade がお客様の申請を審査します。承認されると、口座番号、ログイン情報が発行され、資金の入金手順が電子メールで提供されます。口座番号を取得する前に資金の入金を開始しないでください。",
            complete_app_continue2: "下の [画像をキャプチャ] ボタンをクリックして、デバイスのカメラでドキュメントの鮮明な写真を撮影して送信するか、すでにデバイスにファイルが保存されている場合は、そのファイルをアップロードすることができます。 (メールでお送りいただくことも可能です ",
            mail_to: "service@choicetrade.com",
            complete_app_continue3: "別途、申請書に添付させていただきます。 メールで送信する場合は、必ずアカウント申請時に入力したメールアドレスから送信してください。）",
            capture_image: "キャプチャ画像",
            doc_verification: "書類の検証",
            picture_id: "身分証明書の写真が必要です",
            confirm_doc: "カメラ画面のフレームを満たすように文書を配置してください。",
            retake_photo: "写真を撮り直す",
            photo_text: "写真は鮮明で切れていませんか？"
        },

        welcome_back: {
            welcome_back: "おかえり！",
            click_below: "すでに進行中のアプリケーションを再開するには、以下をクリックしてください。",
            app_in_progress: "申請が完了したか、進行中です。 続行するにはいずれかをクリックしてください。",
            individual: "個人",
            second_app: "2 回目の申請を提出する",
            delete: "消去",
            account: "アカウント",
            started: "に始まりました",
            completed: "完了しました",
            completed_of: "7段階のステップ",
            first_name: "Jeneng Ngarep",
            last_name: "Jeneng Mburi",
            email: "Email",
            phone: "Nomer Telpon",
            saved: "信頼できる連絡先を保存",
            saving: "保存中...",
            trusted_heading: "信頼できる連絡先",
            add_contact: "信頼できる連絡先を追加",
            trusted_text: "Kontak sing dipercaya yaiku wong sing sampeyan wenehi wewenang kanggo dihubungi dening perusahaan keuangan sampeyan ing kahanan tartamtu, kayata yen ana masalah babagan aktivitas ing akun sampeyan lan dheweke ora bisa ngubungi sampeyan. Kontak sing dipercaya bisa uga anggota kulawarga, pengacara, akuntan, utawa pihak katelu liyane sing sampeyan percaya bakal ngajeni privasi sampeyan lan ngerti carane nangani tanggung jawab kasebut. Wong sing dipercaya kudu umur 18 taun utawa luwih."
        },

        logout_modal: {
            logout_text: "アプリケーションの作業が完了したら [OK] をクリックし、ページに留まる場合は [キャンセル] をクリックします。",
            ok: "わかりました",
            cancel: "キャンセル"
        },

        login: {
            login: "ログイン",
            enter_email: "メールアドレスを入力して",
            enter_password: "パスワードを入力する",
            cancel: "キャンセル",
            forget_password: "パスワードをお忘れですか？",
            forgot_password: "パスワードをお忘れですか",
            retrieve_password: "単語を取得するには、以下にメール アドレスを入力してください",
            send_message: "パスワードリセットリンクをあなたのメールアドレスに送信しました",
            acc_not_found: "アカウントが見つかりませんでした！",
            user_not_found: "ユーザーが見つかりません！",
            email: "Eメール",
            new_password: "新しいパスワード",
            confirm_new_password: "新しいパスワードを確認",
        },

        modals: {
            ind_modal: {
                joint1: "联合租户有生存的权利",
                joint2: "在常见的关节租户",
                joint3: "联合与整体租户",
                joint4: "联合社区物业",
            },

            ira_modal: {
                ira: "次に、あなたの IRA 口座の受取人に関する情報を提供してください。",
                close: "近い",
                ira1: "従来の IRA",
                ira2: "ロス・アイラ",
                ira3: "シンプルなアイラ",
                ira4: "カバデル IRA",
                ira5: "9月アイラ",
                ira6: "ロールオーバー IRA"
            },

            special_modal: {
                corporate: "法人の",
                non_profit: "非営利",
                invest_club: "投資クラブ",
                limited_company: "有限責任会社",
                partnership: "パートナーシップ",
                partnership_corp: "パートナーシップ",
                trust: "信頼",
                c_corporation: "C社",
                s_corporation: "S社",
                trust_ssn: "信託は受託者のSSNを使用していますか？",
                trust_id: "信託は独自の納税者番号を持っていますか？",
                close: "近い",
                member: "メンバー"
            }
        },

        specialty: {
            trust_company_name: "信託、会社名または団体名",
            country_of: "設立/組織の国",
            for_accounts: "エンティティアカウントおよび IRA の場合、受託者、認定署名者、または受益者に関する追加情報が必要です。",
            middle_name: "ミドルネーム",
            entity_role: "エンティティの役割",
            president: "社長",
            treasurer: "会計",
            vice_president: "副社長",
            secretary: "秘書",
            add_signer: "別の承認済み署名者を追加する必要があります"
        },

        custodial: {
            thanks: "ありがとう",
            provide_info: "このアカウントを設定する未成年者に関する情報を提供してください。"
        },

        joint: {
            thanks: "ありがとうございました",
            joint_info: "共同所有者の個人情報",
            provide_joint_info: "次",
            joint_account_spouse: "共同口座の所有者は、主要な口座所有者の配偶者ですか？",
            joint_primary_address: "１番目の住所は口座所有者と同じですか？",
            yes: "はい",
            no: "いいえ",
            evening_phone: "夕方の電話",
            are_you_member: "あなたまたはあなたの家族のメンバーは、登録されたブローカー/ディーラー、保険会社、銀行、米国でビジネスを行っている投資顧問、またはSEC、FINRA、NFA、CFTCを含む米国の取引所または自主規制機関に所属または雇用されていますか？ ？",
            indicate: "以下の個人ごとに所有権の割合を示してください"
        },

        tooltip: {
            country_tooltip: "あなたの国がリストにない場合、私たちはあなたの申請を受け入れることができません。 ご質問がある場合は、service@choicetrade.com までメールでお問い合わせください。 カナダの法律により、カナダに居住するカナダ国民は米国のブローカーに口座を開設することを許可されていません。",
            state_tooltip: "ChoiceTrade は米国 50 州と DC で登録されていますが、米国準州では登録されていません。 プエルトリコ、グアム、米領バージン諸島、その他の米国領土からの応募者は残念ながら受け付けることができません。",
            country_tooltip_message: "私の国がリストに載っていないのはなぜですか?",
            state_tooltip_message: "私の州がリストに掲載されていないのはなぜですか?",
            cash_margin_tooltip: "マージン口座とは、融資特権を持つ口座です。 証拠金口座では、新たな購入の際に売上金がすぐに返金されます。 現金口座ではそうすることはできません。 証拠金口座は、株を空売りできる唯一の口座タイプです。 当社の証拠金開示をお読みください。 マージンは現金よりもリスクの高い口座タイプであるため、投資目的が安全性を指している場合、マージンの申請が承認されない可能性があるため、現金口座の申請を検討する必要があります。 証拠金口座に少なくとも 2,000 ドルを入金し、このレベル以上に維持する必要があります。",
            cash_tooltip: "現金口座は、最もシンプルな口座特権です。定義上、証拠金特権のない口座はすべて現金口座です。現金口座では、特定の日に株を購入し、購入が決済される前に売却した場合 (決済日は購入日から 1 営業日後)、売却による収益は売却後 1 営業日まで新しい購入に使用できません。したがって、この理由だけで、証拠金口座が自分に適した口座であると判断できます。"
        },

        about: {
            about_us: "私たちについて",
            about_us1: "アクティブトレーダー、自主的な投資家、株式市場愛好家にとって最高の目的地である ChoiceTrade をご紹介します。 ChoiceTrade は、あらゆるレベルの投資家に力を与えることを目指して設立され、取引体験を簡素化するように設計されたシームレスで直感的な Web ベースの取引プラットフォームを提供します。",
            about_us2: "ChoiceTrade では、株式市場の複雑さを乗り越えることが困難な場合があることを理解しています。 そのため、私たちはわかりやすさと使いやすさを優先し、不必要な混乱や複雑さを排除したプラットフォームを作成しました。 あなたが経験豊富なトレーダーであっても、投資の世界に足を踏み入れたばかりであっても、ChoiceTrade は情報に基づいて自信を持って意思決定を行うために必要なツールとリソースを提供します。",
            about_us3: "私たちの使命はシンプルです。 お客様の取引過程における真の「選択肢」を提供するために。 ChoiceTrade を使用すると、取引の洗練度に関係なく、支払う手数料をはるかに上回るメリット、利便性、サービスが得られると確信できます。",
            about_us4: "ChoiceTrade に参加して、その違いをご自身で体験してください。 お客様のニーズを最優先にしたプラットフォームで、財務上の将来をコントロールしましょう。 卓越したトレーディングの新時代へようこそ。 ChoiceTrade へようこそ。",
        }
    },
}